module.exports = __webpack_public_path__ + "media/react/marketing/sections/faq/assets/question_marks_bg_mobile-f53759f37fde8cea5fd589a3769da29c.svg";